module.exports = __webpack_public_path__ + "static/media/031_IMG_3699.4f29f0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/031_IMG_3699.png
// module id = 530
// module chunks = 0